import { getEnumIsFilterOperator } from './enumFilterOperator';
import { t } from 'i18next';

export const getBoolFilterOperator = () =>
  getEnumIsFilterOperator({
    [t('common.bool.true')]: true,
    [t('common.bool.false')]: false,
  });
